import { cn } from "@/lib/utils";

export const BentoGrid = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "mx-auto grid max-w-7xl grid-cols-1 gap-4 md:grid-cols-3 md:gap-5",
        className,
      )}
    >
      {children}
    </div>
  );
};

export const BentoGridItem = ({
  className,
  title,
  description,
  header,
  icon,
  footer,
}: {
  className?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  header?: React.ReactNode;
  icon?: React.ReactNode;
  footer?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "group/bento relative row-span-1 flex min-h-full flex-col overflow-hidden rounded-2xl border border-primary/[0.08] bg-surface-container-lowest/70 p-4 shadow-sm shadow-primary/[0.03] backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-primary/20 hover:shadow-xl hover:shadow-primary/[0.08] md:p-5",
        className,
      )}
    >
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/45 via-transparent to-primary/[0.04]" />
      <div className="relative z-10">{header}</div>
      <div className="relative z-10 mt-4 transition duration-300 group-hover/bento:translate-x-1">
        {icon}
        <div className="mt-3 mb-1.5 font-display font-bold text-lg text-foreground tracking-tight">
          {title}
        </div>
        <div className="font-body text-sm font-medium text-muted-foreground leading-relaxed">
          {description}
        </div>
        {footer}
      </div>
    </div>
  );
};
